module.exports = __webpack_public_path__ + "images/edges@2x.png?91aa42c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edges@2x.png
// module id = 616
// module chunks = 7